
export class ObjectF {

    id: number = 0;
    description!: string;
    code!: string;
    isList: boolean = false;
    active: boolean = false;
} 